import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "mweb-app-promo-page" */ './Container'));
